import * as Sentry from "@sentry/vue";
import { storeToRefs } from "pinia";
import { watch } from "vue";
import { useRouter } from "vue-router";

import { useIdentityStore } from "@/stores/identity";

function initializeSentryUser(): void {
  if (import.meta.env.VITE_ENVIRONMENT !== "local") {
    const router = useRouter();
    const IdentityStore = useIdentityStore();
    const { userId, userEmail } = storeToRefs(IdentityStore);
    watch(userId, () => {
      if (userId.value > 0) {
        Sentry.setUser({
          id: userId.value,
          email: userEmail.value,
        });
        Sentry.addBreadcrumb({
          category: "auth",
          message: "Authenticated user " + userEmail.value,
          level: "info",
        });
      } else {
        Sentry.setUser(null);
        Sentry.addBreadcrumb({
          category: "auth",
          message: "Logged out user",
          level: "info",
        });
      }
    });
    router.afterEach(() => {
      if (userId.value > 0) {
        Sentry.setUser({
          id: userId.value,
          email: userEmail.value,
        });
      } else {
        Sentry.setUser(null);
      }
    });
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useSentry = () => {
  return {
    Sentry,
    initializeSentryUser,
  };
};
